const DemographicRanges = [
  "13-17",
  "18-24",
  "25-34",
  "35-44",
  "45-54",
  "55-64",
  "65-121",
] as const;

export function getAllDemographicRanges() {
  return DemographicRanges;
}

export type DemographicRange = typeof DemographicRanges[number];
